import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

// Logo - Updated to use white logo
import logoWhite from '../assets/logo-white.svg';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-saverly-primary to-saverly-secondary text-white mt-auto">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src={logoWhite} alt="Saverly - AI-powered meal planning" className="h-8 w-auto" />
            </div>
            <p className="text-white/90 text-lg mb-6 max-w-md leading-relaxed">
              Smart meal planning with AI, powered by your preferences and budget. 
              Save money, eat better, and reduce food waste.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-white/80">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span className="text-sm">support@saverly.com</span>
              </div>
            </div>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">Support</h3>
            <ul className="space-y-4">
              <li>
                <Link 
                  to="/features"
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium group"
                >
                  <span className="group-hover:translate-x-1 transition-transform duration-200 inline-block">
                    Features
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/how-it-works"
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium group"
                >
                  <span className="group-hover:translate-x-1 transition-transform duration-200 inline-block">
                    How It Works
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy-policy"
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium group"
                >
                  <span className="group-hover:translate-x-1 transition-transform duration-200 inline-block">
                    Privacy Policy
                  </span>
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-use"
                  className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium group"
                >
                  <span className="group-hover:translate-x-1 transition-transform duration-200 inline-block">
                    Terms of Use
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-white/10 bg-white/5">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-white/70 text-sm font-medium">
              © {new Date().getFullYear()} Saverly. All rights reserved.
            </p>
            
            {/* Social Media Links */}
            <div className="flex items-center gap-4">
              <span className="text-white/70 text-sm font-medium mr-2">Follow us:</span>
              <div className="flex items-center gap-3">
                <button 
                  type="button"
                  className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 group"
                  onClick={() => console.log('Facebook clicked')}
                >
                  <Facebook className="h-4 w-4 text-white/80 group-hover:text-white transition-colors duration-200" />
                </button>
                <button 
                  type="button"
                  className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 group"
                  onClick={() => console.log('Twitter clicked')}
                >
                  <Twitter className="h-4 w-4 text-white/80 group-hover:text-white transition-colors duration-200" />
                </button>
                <button 
                  type="button"
                  className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 group"
                  onClick={() => console.log('Instagram clicked')}
                >
                  <Instagram className="h-4 w-4 text-white/80 group-hover:text-white transition-colors duration-200" />
                </button>
                <button 
                  type="button"
                  className="p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors duration-200 group"
                  onClick={() => console.log('LinkedIn clicked')}
                >
                  <Linkedin className="h-4 w-4 text-white/80 group-hover:text-white transition-colors duration-200" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 